module.exports = __webpack_public_path__ + "static/img/s20.a00843c8.png";